// index.js

import Vue from "vue"
import VueResource from "vue-resource"
import getUserIP from "./getUserIp.js"
import transform from "./transformResponse"
import checkExpiredToken from "./checkExpiredToken"
import requestInterceptor from "./interceptorRequest"

Vue.use(VueResource)

Vue.http.options.root = process.env.VUE_APP_BASE_API
Vue.http.options.timeout = 60000 * 10

async function configureInterceptors() {
    try {
        const userIP = await getUserIP() // Obtenha o IP do usuário

        // Adicione o interceptor 'request' após a configuração dos cabeçalhos
        Vue.http.interceptors.push((request, next) => {
            // Adicione o IP do usuário ao cabeçalho da solicitação
            request.headers.set("X-User-IP", userIP)
            // Chame o próximo interceptor ou a função next() para continuar com a solicitação
            next()
        })

        // Adicione os interceptadores adicionais
        Vue.http.interceptors.push(transform)
        Vue.http.interceptors.push(checkExpiredToken)
        // Adicione o interceptor de solicitação como o último interceptor
        Vue.http.interceptors.push((request, next) => {
            requestInterceptor(request, next) // Chame o interceptor requestInterceptor
        })
    } catch (error) {
        console.error("Erro ao configurar os interceptadores:", error)
    }
}

configureInterceptors();
export default VueResource








// import Vue from "vue"
// import VueResource from "vue-resource"
// import getUserIP from "./getUserIp.js"
// import transform from "./transformResponse"
// import checkExpiredToken from "./checkExpiredToken"
// import requestInterceptor from "./interceptorRequest"

// Vue.use(VueResource)

// Vue.http.options.root = process.env.VUE_APP_BASE_API
// Vue.http.options.timeout = 60000 * 10

// async function configureInterceptors() {
// 	try {
// 		const userIP = await getUserIP() // Obtenha o IP do usuário

// 		// Adicione o interceptor 'request' após a configuração dos cabeçalhos
// 		Vue.http.interceptors.push((request, next) => {
// 			// Adicione o IP do usuário ao cabeçalho da solicitação
// 			request.headers.set("X-User-IP", userIP)

// 			// Chame o próximo interceptor ou a função next() para continuar com a solicitação
// 			next()
// 		})

// 		// Adicione os interceptadores adicionais
// 		Vue.http.interceptors.push(transform)
// 		Vue.http.interceptors.push(checkExpiredToken)

// 		// Adicione o interceptor de solicitação como o último interceptor
// 		Vue.http.interceptors.push((request, next) => {
// 			requestInterceptor(request, next) // Chame o interceptor requestInterceptor
// 		})
// 	} catch (error) {
// 		console.error("Erro ao configurar os interceptadores:", error)
// 	}
// }

// configureInterceptors();
// export default VueResource